module.exports = __webpack_public_path__ + "static/media/cat_won.64a62fc9.svg";